export const ARCA_MODULE_NAME = "arca_module";

export const arcaModuleMenuItem = {
  icon: "file-invoice-dollar",
  path: "/arca",
};

export const arcaModuleRoutes = [
  {
    path: "arca",
    name: "ArcaConfig",
    components: {
      default: () => import("./pages/ArcaConfig.vue"),
    },
    meta: {
      title: "ARCA",
      requiresAuth: true,
      requiresModule: ARCA_MODULE_NAME,
    },
  },
];

export default {
  moduleName: ARCA_MODULE_NAME,
  routes: arcaModuleRoutes,
  menuItem: arcaModuleMenuItem,
};
